import {API} from '../common/axios'

export type CachedProduct = {
    sku: string
    cost: number
    bin: string | null
    model: string | null
    serialized: boolean
}

/* Map key is SKU */
export type CachedProductMap = Record<string, CachedProduct>

let cachedProducts: CachedProductMap = {}

export const getCachedProducts = async (
    refresh: boolean = false
): Promise<CachedProductMap> => {
    if (!refresh) {
        for (let p in cachedProducts) return cachedProducts // loop iterated, the map is NOT empty
    }

    let params = {
        page_size: '6000', // ~4000 products: 350K
        discontinued: 'false',
        inventory_types: 'merch',
        fields: 'sku,cost,truck_bin,model_number,serialized'
    }

    /* refresh or initial load */
    let response = await API.get('inventory/products', {params})

    /* convert to a map for fast lookups by SKU */
    cachedProducts = {}
    response.data.forEach(
        (p: any) =>
            (cachedProducts[p.sku] = {
                sku: p.sku,
                cost: p.cost,
                bin: p.truck_bin,
                model: p.model_number,
                serialized: p.serialized
            })
    )

    return cachedProducts
}
